import { FormCategory } from "../../enums";
import { ExportFormType, ExportPaymentsType, } from "../../enums/export";
import { CommandFulfillmentStatus, FulfillmentMethod } from "../../enums/fulfillment";
import { Locales } from "../enums/locales";
const paymentExportColumnsConfig = ({ exportFormType, exportType, timezone, hideCampaignInfo, canGenerateReceipt, canRecordDaf, }) => {
    const isAllForms = exportFormType === ExportFormType.AllForms;
    const isEvent = exportFormType === ExportFormType.Event;
    const isCustom = exportFormType === ExportFormType.Custom;
    const isDrawing = exportFormType === ExportFormType.Raffle || exportFormType === ExportFormType.Sweepstakes;
    const isAuction = exportFormType === ExportFormType.Auction;
    const isMembership = exportFormType === ExportFormType.Membership;
    const isPeerToPeer = exportFormType === ExportFormType.PeerToPeer;
    const isDonationFormOrCampaign = exportFormType === ExportFormType.DonationForm || exportFormType === ExportFormType.PeerToPeer;
    return {
        // Détails de la transaction
        transactionDetail: {
            createdAt: {
                formatLabel: (labels) => labels.split("(")?.[0],
                hidden: false,
                labels: {
                    [Locales.FR]: `Date du paiement (${timezone})`,
                    [Locales.EN]: `Payment Date (${timezone})`,
                    [Locales.ES]: `Fecha de pago (${timezone})`,
                    [Locales.DE]: `Zahlungsdatum (${timezone})`,
                },
            },
            createdAtTimestamp: {
                formatLabel: (labels) => labels.split("(")?.[0],
                hidden: true,
                labels: {
                    [Locales.FR]: `Heure du paiement (${timezone})`,
                    [Locales.EN]: `Payment Time (${timezone})`,
                    [Locales.ES]: `Hora del pago (${timezone})`,
                    [Locales.DE]: `Zahlungszeit (${timezone})`,
                },
            },
            totalAmount: {
                hidden: false,
                labels: {
                    [Locales.FR]: "Montant total",
                    [Locales.EN]: "Total Amount",
                    [Locales.ES]: "Monto total",
                    [Locales.DE]: "Gesamtbetrag",
                },
            },
            dafProvider: {
                hidden: !canRecordDaf,
                labels: {
                    [Locales.FR]: "Fournisseur DAF",
                    [Locales.EN]: "DAF provider",
                    [Locales.ES]: "Proveedor DAF",
                    [Locales.DE]: "DAF-Anbieter",
                },
            },
            paymentMethod: {
                hidden: false,
                labels: {
                    [Locales.FR]: "Méthode de paiement",
                    [Locales.EN]: "Payment Method",
                    [Locales.ES]: "Método de pago",
                    [Locales.DE]: "Zahlungsmethode",
                },
            },
            status: {
                hidden: false,
                labels: {
                    [Locales.FR]: "Statut du paiement",
                    [Locales.EN]: "Payment Status",
                    [Locales.ES]: "Estado del pago",
                    [Locales.DE]: "Zahlungsstatus",
                },
            },
            payoutDate: {
                hidden: false,
                labels: {
                    [Locales.FR]: "Date de versement",
                    [Locales.EN]: "Payout Date",
                    [Locales.ES]: "Fecha de desembolso",
                    [Locales.DE]: "Auszahlungsdatum",
                },
            },
            extraDonation: {
                hidden: isDonationFormOrCampaign || exportType === ExportPaymentsType.ItemizedPayments,
                tooltip: "exportModal.tooltip.extraDonation",
                labels: {
                    [Locales.FR]: "Don additionnel",
                    [Locales.EN]: "Extra Donation",
                    [Locales.ES]: "Donación extra",
                    [Locales.DE]: "Zusätzliche Spende",
                },
            },
            refundedAmount: {
                hidden: false,
                labels: {
                    [Locales.FR]: "Montant remboursé",
                    [Locales.EN]: "Refund Amount",
                    [Locales.ES]: "Monto reembolsado",
                    [Locales.DE]: "Erstattungsbetrag",
                },
            },
            recurringStatus: {
                tooltip: isDonationFormOrCampaign ? "exportModal.tooltip.frequency" : "exportModal.tooltip.recurringStatus",
                hidden: !(isMembership || isDonationFormOrCampaign || isAllForms),
                labels: {
                    [Locales.FR]: "Statut récurrent",
                    [Locales.EN]: "Recurring Status",
                    [Locales.ES]: "Estado recurrente",
                    [Locales.DE]: "Wiederkehrender Status",
                },
            },
            discount: {
                hidden: isDonationFormOrCampaign || isAuction,
                labels: {
                    [Locales.FR]: "Code de réduction",
                    [Locales.EN]: "Discount",
                    [Locales.ES]: "Descuento",
                    [Locales.DE]: "Rabatt",
                },
            },
            taxes: {
                hidden: isDonationFormOrCampaign,
                tooltip: "exportModal.tooltip.taxes",
                labels: {
                    [Locales.FR]: "Taxes de vente",
                    [Locales.EN]: "Sales taxes",
                    [Locales.ES]: "Impuestos sobre las ventas",
                    [Locales.DE]: "Umsatzsteuern",
                },
            },
            selectedFund: {
                hidden: false,
                labels: {
                    [Locales.FR]: "Fonds",
                    [Locales.EN]: "Fund",
                    [Locales.ES]: "Fondo",
                    [Locales.DE]: "Fonds",
                },
            },
        },
        // Informations de l'acheteur
        buyerInfo: {
            firstName: {
                hidden: false,
                labels: {
                    [Locales.FR]: "Prénom",
                    [Locales.EN]: "First Name",
                    [Locales.ES]: "Nombre",
                    [Locales.DE]: "Vorname",
                },
            },
            lastName: {
                hidden: false,
                labels: {
                    [Locales.FR]: "Nom",
                    [Locales.EN]: "Last Name",
                    [Locales.ES]: "Apellido",
                    [Locales.DE]: "Nachname",
                },
            },
            email: {
                hidden: false,
                labels: {
                    [Locales.FR]: "Courriel",
                    [Locales.EN]: "Email",
                    [Locales.ES]: "Correo electrónico",
                    [Locales.DE]: "E-Mail",
                },
            },
            companyName: {
                hidden: false,
                labels: {
                    [Locales.FR]: "Nom de l'entreprise",
                    [Locales.EN]: "Company Name",
                    [Locales.ES]: "Nombre de la empresa",
                    [Locales.DE]: "Firmenname",
                },
            },
            address: {
                hidden: false,
                labels: {
                    [Locales.FR]: "Adresse",
                    [Locales.EN]: "Address",
                    [Locales.ES]: "Dirección",
                    [Locales.DE]: "Adresse",
                },
            },
            city: {
                hidden: false,
                labels: {
                    [Locales.FR]: "Ville",
                    [Locales.EN]: "City",
                    [Locales.ES]: "Ciudad",
                    [Locales.DE]: "Stadt",
                },
            },
            postalCode: {
                hidden: false,
                labels: {
                    [Locales.FR]: "Code postal",
                    [Locales.EN]: "Postal Code",
                    [Locales.ES]: "Código postal",
                    [Locales.DE]: "Postleitzahl",
                },
            },
            region: {
                hidden: false,
                labels: {
                    [Locales.FR]: "Province",
                    [Locales.EN]: "State",
                    [Locales.ES]: "Estado",
                    [Locales.DE]: "Bundesland",
                },
            },
            country: {
                hidden: false,
                labels: {
                    [Locales.FR]: "Pays",
                    [Locales.EN]: "Country",
                    [Locales.ES]: "País",
                    [Locales.DE]: "Land",
                },
            },
            locale: {
                hidden: false,
                labels: {
                    [Locales.FR]: "Langue",
                    [Locales.EN]: "Language",
                    [Locales.ES]: "Idioma",
                    [Locales.DE]: "Sprache",
                },
            },
        },
        // Informations fiscales et reçus
        taxReceiptInfo: {
            receiptNumber: {
                hidden: !canGenerateReceipt,
                labels: {
                    [Locales.FR]: "N° de reçu fiscal",
                    [Locales.EN]: "Tax Receipt #",
                    [Locales.ES]: "# de recibo fiscal",
                    [Locales.DE]: "Spendenbescheinigung Nr.",
                },
            },
            receiptUrl: {
                hidden: !canGenerateReceipt,
                labels: {
                    [Locales.FR]: "URL du reçu fiscal",
                    [Locales.EN]: "Tax Receipt URL",
                    [Locales.ES]: "URL del recibo fiscal",
                    [Locales.DE]: "Spendenbescheinigung-URL",
                },
            },
            eligibleAmount: {
                tooltip: "exportModal.tooltip.eligibleAmount",
                hidden: isDonationFormOrCampaign || !canGenerateReceipt,
                labels: {
                    [Locales.FR]: "Montant admissible",
                    [Locales.EN]: "Eligible Amount",
                    [Locales.ES]: "Monto elegible",
                    [Locales.DE]: "Abzugsfähiger Betrag",
                },
            },
        },
        // Informations sur les billets / articles
        ticketInfo: {
            details: {
                tooltip: "exportModal.tooltip.details",
                hidden: exportType === ExportPaymentsType.ItemizedPayments || isDonationFormOrCampaign,
                labels: {
                    [Locales.FR]: "Détails",
                    [Locales.EN]: "Details",
                    [Locales.ES]: "Detalles",
                    [Locales.DE]: "Details",
                },
            },
            rateTitle: {
                hidden: exportType === ExportPaymentsType.Payments || isDonationFormOrCampaign,
                labels: {
                    [Locales.FR]: "Titre du tarif",
                    [Locales.EN]: "Rate Title",
                    [Locales.ES]: "Título de tarifa",
                    [Locales.DE]: "Tarifbezeichnung",
                },
            },
            bidStatus: {
                hidden: exportType === ExportPaymentsType.Payments || !(isAuction || isAllForms),
                labels: {
                    [Locales.FR]: "Statut",
                    [Locales.EN]: "Status",
                    [Locales.ES]: "Estado",
                    [Locales.DE]: "Status",
                },
            },
            itemAmount: {
                hidden: exportType === ExportPaymentsType.Payments || isDonationFormOrCampaign,
                labels: {
                    [Locales.FR]: "Montant de l'article",
                    [Locales.EN]: "Item Amount",
                    [Locales.ES]: "Monto del artículo",
                    [Locales.DE]: "Artikelbetrag",
                },
            },
            ticketNumber: {
                hidden: exportType === ExportPaymentsType.Payments || isDonationFormOrCampaign || isAuction,
                labels: {
                    [Locales.FR]: "N° de billet",
                    [Locales.EN]: "Ticket #",
                    [Locales.ES]: "# de boleto",
                    [Locales.DE]: "Ticket-Nr.",
                },
            },
            addOnNumber: {
                hidden: exportType === ExportPaymentsType.Payments || isDonationFormOrCampaign || isAuction,
                labels: {
                    [Locales.FR]: "N° d'extra",
                    [Locales.EN]: "Add-on #",
                    [Locales.ES]: "# de complemento",
                    [Locales.DE]: "Add-on-Nr.",
                },
            },
            eTicketUrl: {
                hidden: exportType === ExportPaymentsType.Payments || isDonationFormOrCampaign || isAuction,
                labels: {
                    [Locales.FR]: "URL du billet électronique",
                    [Locales.EN]: "E-ticket URL",
                    [Locales.ES]: "URL del boleto electrónico",
                    [Locales.DE]: "E-Ticket-URL",
                },
            },
            canceled: {
                hidden: exportType === ExportPaymentsType.Payments || isDonationFormOrCampaign,
                labels: {
                    [Locales.FR]: "Billets annulés",
                    [Locales.EN]: "Canceled Tickets",
                    [Locales.ES]: "Boletos cancelados",
                    [Locales.DE]: "Stornierte Tickets",
                },
            },
            occurrence: {
                tooltip: "exportModal.tooltip.occurrence",
                hidden: !(isEvent || isCustom || isDrawing || isAllForms),
                labels: {
                    [Locales.FR]: "Occurrence",
                    [Locales.EN]: "Occurrence",
                    [Locales.ES]: "Ocurrencia",
                    [Locales.DE]: "Termin",
                },
            },
            expirationDate: {
                tooltip: "exportModal.tooltip.expirationDate",
                hidden: !(isMembership || isAllForms),
                labels: {
                    [Locales.FR]: "Date d'expiration",
                    [Locales.EN]: "Expiration Date",
                    [Locales.ES]: "Fecha de vencimiento",
                    [Locales.DE]: "Ablaufdatum",
                },
            },
            scans: {
                tooltip: "exportModal.tooltip.scans",
                hidden: exportType === ExportPaymentsType.Payments || !(isEvent || isCustom || isDrawing || isAllForms),
                labels: {
                    [Locales.FR]: "Scans de billets",
                    [Locales.EN]: "Ticket Scans",
                    [Locales.ES]: "Escaneos de billetes",
                    [Locales.DE]: "Ticket-Scans",
                },
            },
            lastScan: {
                tooltip: "exportModal.tooltip.lastScan",
                hidden: exportType === ExportPaymentsType.Payments || !(isEvent || isCustom || isDrawing || isAllForms),
                labels: {
                    [Locales.FR]: "Dernier scan",
                    [Locales.EN]: "Last Scan Date",
                    [Locales.ES]: "Último escaneo",
                    [Locales.DE]: "Letztes Scan-Datum",
                },
            },
        },
        // Informations sur le formulaire
        formInfo: {
            formTitle: {
                hidden: false,
                labels: {
                    [Locales.FR]: "Titre de la campagne",
                    [Locales.EN]: "Campaign Title",
                    [Locales.ES]: "Título de la campaña",
                    [Locales.DE]: "Kampagnentitel",
                },
            },
            formLink: {
                hidden: false,
                labels: {
                    [Locales.FR]: "Lien de la campagne",
                    [Locales.EN]: "Campaign Link",
                    [Locales.ES]: "Enlace de la campaña",
                    [Locales.DE]: "Kampagnenlink",
                },
            },
            campaignTitle: {
                tooltip: "exportModal.tooltip.campaignTitle",
                hidden: !(isPeerToPeer || isAllForms) || Boolean(hideCampaignInfo),
                labels: {
                    [Locales.FR]: "Titre de la campagne principale",
                    [Locales.EN]: "Main Campaign Title",
                    [Locales.ES]: "Título de la campaña principal",
                    [Locales.DE]: "Titel der Hauptkampagne",
                },
            },
            teamTitle: {
                tooltip: "exportModal.tooltip.teamTitle",
                hidden: !(isPeerToPeer || isAllForms) || Boolean(hideCampaignInfo),
                labels: {
                    [Locales.FR]: "Titre de l'équipe",
                    [Locales.EN]: "Team Title",
                    [Locales.ES]: "Título del equipo",
                    [Locales.DE]: "Teamname",
                },
            },
            teamCreationDate: {
                tooltip: "exportModal.tooltip.teamCreationDate",
                hidden: !(isPeerToPeer || isAllForms) || Boolean(hideCampaignInfo),
                labels: {
                    [Locales.FR]: "Date de création de l'équipe",
                    [Locales.EN]: "Team Creation Date",
                    [Locales.ES]: "Fecha de creación del equipo",
                    [Locales.DE]: "Team-Erstellungsdatum",
                },
            },
        },
        // Informations supplémentaires
        otherInfo: {
            note: {
                hidden: false,
                labels: {
                    [Locales.FR]: "Note",
                    [Locales.EN]: "Note",
                    [Locales.ES]: "Nota",
                    [Locales.DE]: "Notiz",
                },
            },
            inHonourName: {
                hidden: !(isDonationFormOrCampaign || isAllForms),
                labels: {
                    [Locales.FR]: "En l'honneur ou à la mémoire de",
                    [Locales.EN]: "In Honour/Memory of",
                    [Locales.ES]: "En honor o en memoria de",
                    [Locales.DE]: "Zu Ehren/Im Gedenken an",
                },
            },
            customQuestions: exportType === ExportPaymentsType.Payments
                ? {
                    hidden: false,
                    labels: {
                        [Locales.FR]: "Questions pour l'acheteur",
                        [Locales.EN]: "Buyer questions",
                        [Locales.ES]: "Preguntas para el comprador",
                        [Locales.DE]: "Fragen an Käufer",
                    },
                }
                : {
                    tooltip: "exportModal.tooltip.customQuestions",
                    hidden: false,
                    labels: {
                        [Locales.FR]: "Questions personnalisées",
                        [Locales.EN]: "Custom questions",
                        [Locales.ES]: "Preguntas personalizadas",
                        [Locales.DE]: "Benutzerdefinierte Fragen",
                    },
                },
            paymentHandler: {
                hidden: false,
                labels: {
                    [Locales.FR]: "Responsable du paiement",
                    [Locales.EN]: "Payment handler",
                    [Locales.ES]: "Responsable del pago",
                    [Locales.DE]: "Zahlungsverantwortliche(r)",
                },
            },
        },
    };
};
const guestListExportColumnsConfig = {
    guestFirstName: {
        labels: {
            [Locales.FR]: "Prénom de l'invité",
            [Locales.EN]: "Guest first name",
            [Locales.ES]: "Nombre del invitado",
            [Locales.DE]: "Vorname des Gastes",
        },
    },
    guestLastName: {
        labels: {
            [Locales.FR]: "Nom de l'invité",
            [Locales.EN]: "Guest last name",
            [Locales.ES]: "Apellido del invitado",
            [Locales.DE]: "Nachname des Gastes",
        },
    },
    guestEmail: {
        labels: {
            [Locales.FR]: "Courriel de l'invité",
            [Locales.EN]: "Guest email",
            [Locales.ES]: "Correo electrónico del invitado",
            [Locales.DE]: "E-Mail des Gastes",
        },
    },
    guestAddress: {
        labels: {
            [Locales.FR]: "Adresse de l'invité",
            [Locales.EN]: "Guest address",
            [Locales.ES]: "Dirección del invitado",
            [Locales.DE]: "Adresse des Gastes",
        },
    },
    guestCity: {
        labels: {
            [Locales.FR]: "Ville de l'invité",
            [Locales.EN]: "Guest city",
            [Locales.ES]: "Ciudad del invitado",
            [Locales.DE]: "Stadt des Gastes",
        },
    },
    guestRegion: {
        labels: {
            [Locales.FR]: "Région de l'invité",
            [Locales.EN]: "Guest region",
            [Locales.ES]: "Región del invitado",
            [Locales.DE]: "Region des Gastes",
        },
    },
    guestPostalCode: {
        labels: {
            [Locales.FR]: "Code postal de l'invité",
            [Locales.EN]: "Guest postal code",
            [Locales.ES]: "Código postal del invitado",
            [Locales.DE]: "Postleitzahl des Gastes",
        },
    },
    guestCountry: {
        labels: {
            [Locales.FR]: "Pays de l'invité",
            [Locales.EN]: "Guest country",
            [Locales.ES]: "País del invitado",
            [Locales.DE]: "Land des Gastes",
        },
    },
    buyerFirstName: {
        labels: {
            [Locales.FR]: "Prénom de l'acheteur",
            [Locales.EN]: "Buyer first name",
            [Locales.ES]: "Nombre del comprador",
            [Locales.DE]: "Vorname des Käufers",
        },
    },
    buyerLastName: {
        labels: {
            [Locales.FR]: "Nom de l'acheteur",
            [Locales.EN]: "Buyer last name",
            [Locales.ES]: "Apellido del comprador",
            [Locales.DE]: "Nachname des Käufers",
        },
    },
    buyerAddress: {
        labels: {
            [Locales.FR]: "Adresse de l'acheteur",
            [Locales.EN]: "Buyer address",
            [Locales.ES]: "Dirección del comprador",
            [Locales.DE]: "Adresse des Käufers",
        },
    },
    buyerCity: {
        labels: {
            [Locales.FR]: "Ville de l'acheteur",
            [Locales.EN]: "Buyer city",
            [Locales.ES]: "Ciudad del comprador",
            [Locales.DE]: "Stadt des Käufers",
        },
    },
    buyerRegion: {
        labels: {
            [Locales.FR]: "Région de l'acheteur",
            [Locales.EN]: "Buyer region",
            [Locales.ES]: "Región del comprador",
            [Locales.DE]: "Region des Käufers",
        },
    },
    buyerPostalCode: {
        labels: {
            [Locales.FR]: "Code postal de l'acheteur",
            [Locales.EN]: "Buyer postal code",
            [Locales.ES]: "Código postal del comprador",
            [Locales.DE]: "Postleitzahl des Käufers",
        },
    },
    buyerCountry: {
        labels: {
            [Locales.FR]: "Pays de l'acheteur",
            [Locales.EN]: "Buyer country",
            [Locales.ES]: "País del comprador",
            [Locales.DE]: "Land des Käufers",
        },
    },
    buyerEmail: {
        labels: {
            [Locales.FR]: "Courriel de l'acheteur",
            [Locales.EN]: "Buyer email",
            [Locales.ES]: "Correo electrónico del comprador",
            [Locales.DE]: "Käufer-E-Mail",
        },
    },
    ticketNumber: {
        labels: {
            [Locales.FR]: "Numéro de billet",
            [Locales.EN]: "Ticket number",
            [Locales.ES]: "Número de boleto",
            [Locales.DE]: "Ticketnummer",
        },
    },
    addOnNumber: {
        labels: {
            [Locales.FR]: "Numéro d'extra",
            [Locales.EN]: "Add-on number",
            [Locales.ES]: "Número de complemento",
            [Locales.DE]: "Add-on-Nummer",
        },
    },
    ticketType: {
        labels: {
            [Locales.FR]: "Type de billet",
            [Locales.EN]: "Ticket type",
            [Locales.ES]: "Tipo de boleto",
            [Locales.DE]: "Tickettyp",
        },
    },
    customQuestions: {
        labels: {
            [Locales.FR]: "Questions personnalisées",
            [Locales.EN]: "Custom questions",
            [Locales.ES]: "Preguntas personalizadas",
            [Locales.DE]: "Benutzerdefinierte Fragen",
        },
    },
    eventDate: {
        labels: {
            [Locales.FR]: "Date de l'événement",
            [Locales.EN]: "Event date",
            [Locales.ES]: "Fecha del evento",
            [Locales.DE]: "Veranstaltungsdatum",
        },
    },
    ticketNotes: {
        labels: {
            [Locales.FR]: "Notes du billet",
            [Locales.EN]: "Ticket notes",
            [Locales.ES]: "Notas del boleto",
            [Locales.DE]: "Ticketnotizen",
        },
    },
    status: {
        labels: {
            [Locales.FR]: "Statut",
            [Locales.EN]: "Status",
            [Locales.ES]: "Estado",
            [Locales.DE]: "Status",
        },
    },
};
const fulfillmentExportColumnsConfig = {
    buyerName: {
        labels: {
            [Locales.FR]: "Nom de l'acheteur",
            [Locales.EN]: "Buyer name",
            [Locales.ES]: "Nombre completo del comprador",
            [Locales.DE]: "Käufername",
        },
    },
    buyerEmail: {
        labels: {
            [Locales.FR]: "Courriel de l'acheteur",
            [Locales.EN]: "Buyer email",
            [Locales.ES]: "Correo electrónico del comprador",
            [Locales.DE]: "Käufer-E-Mail",
        },
    },
    items: {
        labels: {
            [Locales.FR]: "Articles",
            [Locales.EN]: "Items",
            [Locales.ES]: "Artículos",
            [Locales.DE]: "Artikel",
        },
    },
    questionsAndNotes: {
        labels: {
            [Locales.FR]: "Questions et notes",
            [Locales.EN]: "Questions and notes",
            [Locales.ES]: "Preguntas y notas",
            [Locales.DE]: "Fragen und Notizen",
        },
    },
    deliveryMethod: {
        labels: {
            [Locales.FR]: "Mode de livraison",
            [Locales.EN]: "Delivery method",
            [Locales.ES]: "Método de entrega",
            [Locales.DE]: "Liefermethode",
        },
    },
    fulfillmentStatus: {
        labels: {
            [Locales.FR]: "Statut de traitement",
            [Locales.EN]: "Fulfillment status",
            [Locales.ES]: "Estado de cumplimiento",
            [Locales.DE]: "Abwicklungsstatus",
        },
    },
    shippingAddress: {
        labels: {
            [Locales.FR]: "Adresse de livraison",
            [Locales.EN]: "Shipping address",
            [Locales.ES]: "Dirección de envío",
            [Locales.DE]: "Lieferadresse",
        },
    },
};
export const getFulfillmentExportColumns = ({ locale, }) => {
    const columnsHeaders = Object.entries(fulfillmentExportColumnsConfig).reduce((acc, [key, value]) => {
        return { ...acc, [key]: value.labels[locale] };
    }, {});
    return { columnsHeaders };
};
export const fulfillmentExportStatusLabels = (status) => {
    switch (status) {
        case CommandFulfillmentStatus.NotFulfilled:
            return {
                [Locales.FR]: "Non traité",
                [Locales.EN]: "Not fulfilled",
                [Locales.ES]: "No cumplido",
                [Locales.DE]: "Nicht abgewickelt",
            };
        case CommandFulfillmentStatus.PartiallyReady:
            return {
                [Locales.FR]: "Partiellement prêt",
                [Locales.EN]: "Partially ready",
                [Locales.ES]: "Parcialmente listo",
                [Locales.DE]: "Teilweise bereit",
            };
        case CommandFulfillmentStatus.Ready:
            return {
                [Locales.FR]: "Prêt",
                [Locales.EN]: "Ready",
                [Locales.ES]: "Listo",
                [Locales.DE]: "Bereit",
            };
        case CommandFulfillmentStatus.PartiallyFulfilled:
            return {
                [Locales.FR]: "Partiellement traité",
                [Locales.EN]: "Partially fulfilled",
                [Locales.ES]: "Parcialmente cumplido",
                [Locales.DE]: "Teilweise abgewickelt",
            };
        case CommandFulfillmentStatus.Fulfilled:
            return {
                [Locales.FR]: "Traité",
                [Locales.EN]: "Fulfilled",
                [Locales.ES]: "Cumplido",
                [Locales.DE]: "Abgewickelt",
            };
        default:
            return {
                [Locales.FR]: "Inconnu",
                [Locales.EN]: "Unknown",
                [Locales.ES]: "Desconocido",
                [Locales.DE]: "Unbekannt",
            };
    }
};
export const fulfillmentExportDeliveryLabels = (method) => {
    switch (method) {
        case FulfillmentMethod.Pickup:
            return {
                [Locales.FR]: "Cueillette",
                [Locales.EN]: "Pick-up",
                [Locales.ES]: "Recogida",
                [Locales.DE]: "Abholung",
            };
        case FulfillmentMethod.Shipping:
            return {
                [Locales.FR]: "Expédition",
                [Locales.EN]: "Shipping",
                [Locales.ES]: "Envío",
                [Locales.DE]: "Versand",
            };
        default:
            return {
                [Locales.FR]: "",
                [Locales.EN]: "",
                [Locales.ES]: "",
                [Locales.DE]: "",
            };
    }
};
const CANCELED_LABELS = {
    [Locales.FR]: "Annulé",
    [Locales.EN]: "Canceled",
    [Locales.ES]: "Cancelado",
    [Locales.DE]: "Storniert",
};
export const addOnRedemptionStatusLabels = (status) => {
    if (status === "checkedIn") {
        return {
            [Locales.FR]: "Utilisé",
            [Locales.EN]: "Redeemed",
            [Locales.ES]: "Utilizado",
            [Locales.DE]: "Eingelöst",
        };
    }
    if (status === "notCheckedIn") {
        return {
            [Locales.FR]: "Non utilisé",
            [Locales.EN]: "Not redeemed",
            [Locales.ES]: "No utilizado",
            [Locales.DE]: "Nicht eingelöst",
        };
    }
    return CANCELED_LABELS;
};
export const sweepstakesEntryExportStatusLabels = (status) => {
    if (status === "canceled") {
        return CANCELED_LABELS;
    }
    return {
        [Locales.FR]: "Active",
        [Locales.EN]: "Active",
        [Locales.ES]: "Activa",
        [Locales.DE]: "Aktiv",
    };
};
export const guestListExportStatusLabels = (status, formCategory) => {
    const isShop = formCategory === FormCategory.Shop;
    if (status === "checkedIn") {
        return {
            [Locales.FR]: isShop ? "Livré" : "Enregistré",
            [Locales.EN]: isShop ? "Delivered" : "Checked-in",
            [Locales.ES]: "Presente",
            [Locales.DE]: isShop ? "Geliefert" : "Eingecheckt",
        };
    }
    if (status === "notCheckedIn") {
        return {
            [Locales.FR]: isShop ? "Non livré" : "Non-enregistré",
            [Locales.EN]: isShop ? "Not delivered" : "Not checked-in",
            [Locales.ES]: "No presente",
            [Locales.DE]: isShop ? "Nicht geliefert" : "Nicht eingecheckt",
        };
    }
    if (status === "canceled") {
        return CANCELED_LABELS;
    }
    return {
        [Locales.FR]: "Inconnu",
        [Locales.EN]: "Unknown",
        [Locales.ES]: "Desconocido",
        [Locales.DE]: "Unbekannt",
    };
};
export const getPaymentExportColumns = ({ exportFormType, exportType, timezone, locale, hideCampaignInfo, canGenerateReceipt, canRecordDaf, }) => {
    const config = paymentExportColumnsConfig({
        exportFormType,
        exportType,
        timezone,
        hideCampaignInfo,
        canGenerateReceipt,
        canRecordDaf,
    });
    const baseColumnsHeaders = Object.entries(config).reduce((acc, [_key, value]) => {
        const valueV = Object.entries(value).reduce((acc, [key, value]) => {
            if (value.hidden) {
                return acc;
            }
            return { ...acc, [key]: value.labels[locale] };
        }, {});
        return { ...acc, ...valueV };
    }, {});
    const createdAtTimestampConfig = config.transactionDetail.createdAtTimestamp;
    const columnsHeaders = Object.keys(baseColumnsHeaders).reduce((acc, key) => {
        acc[key] = baseColumnsHeaders[key];
        if (key === "createdAt" && createdAtTimestampConfig) {
            acc.createdAtTimestamp = createdAtTimestampConfig.labels[locale];
        }
        return acc;
    }, {});
    return { columnsHeaders, config };
};
const sweepstakesGuestListColumnLabels = {
    guestFirstName: {
        [Locales.FR]: "Prénom du titulaire",
        [Locales.EN]: "Entry holder first name",
        [Locales.ES]: "Nombre del titular",
        [Locales.DE]: "Vorname des Inhabers",
    },
    guestLastName: {
        [Locales.FR]: "Nom du titulaire",
        [Locales.EN]: "Entry holder last name",
        [Locales.ES]: "Apellido del titular",
        [Locales.DE]: "Nachname des Inhabers",
    },
    guestEmail: {
        [Locales.FR]: "Courriel du titulaire",
        [Locales.EN]: "Entry holder email",
        [Locales.ES]: "Correo electrónico del titular",
        [Locales.DE]: "E-Mail des Inhabers",
    },
    guestAddress: {
        [Locales.FR]: "Adresse du titulaire",
        [Locales.EN]: "Entry holder address",
        [Locales.ES]: "Dirección del titular",
        [Locales.DE]: "Adresse des Inhabers",
    },
    guestCity: {
        [Locales.FR]: "Ville du titulaire",
        [Locales.EN]: "Entry holder city",
        [Locales.ES]: "Ciudad del titular",
        [Locales.DE]: "Stadt des Inhabers",
    },
    guestRegion: {
        [Locales.FR]: "Province/État du titulaire",
        [Locales.EN]: "Entry holder region",
        [Locales.ES]: "Región del titular",
        [Locales.DE]: "Region des Inhabers",
    },
    guestPostalCode: {
        [Locales.FR]: "Code postal du titulaire",
        [Locales.EN]: "Entry holder postal code",
        [Locales.ES]: "Código postal del titular",
        [Locales.DE]: "Postleitzahl des Inhabers",
    },
    guestCountry: {
        [Locales.FR]: "Pays du titulaire",
        [Locales.EN]: "Entry holder country",
        [Locales.ES]: "País del titular",
        [Locales.DE]: "Land des Inhabers",
    },
    ticketNumber: {
        [Locales.FR]: "Numéro de participation",
        [Locales.EN]: "Entry number",
        [Locales.ES]: "Número de participación",
        [Locales.DE]: "Teilnahmenummer",
    },
    ticketType: {
        [Locales.FR]: "Type de participation",
        [Locales.EN]: "Entry type",
        [Locales.ES]: "Tipo de participación",
        [Locales.DE]: "Teilnahmeart",
    },
    ticketNotes: {
        [Locales.FR]: "Notes de participation",
        [Locales.EN]: "Entry notes",
        [Locales.ES]: "Notas de la participación",
        [Locales.DE]: "Teilnahmenotizen",
    },
};
export const getGuestListExportColumns = ({ locale, formCategory, }) => {
    const isSweepstakes = formCategory === FormCategory.Sweepstakes;
    const columnsHeaders = Object.entries(guestListExportColumnsConfig).reduce((acc, [key, value]) => {
        const sweepstakesLabels = isSweepstakes
            ? sweepstakesGuestListColumnLabels[key]
            : undefined;
        return { ...acc, [key]: (sweepstakesLabels ?? value.labels)[locale] };
    }, {});
    return { columnsHeaders };
};
export const exportTotalTaxesColumnLabels = {
    [Locales.FR]: "Total des taxes",
    [Locales.EN]: "Total taxes",
    [Locales.ES]: "Total de impuestos",
    [Locales.DE]: "Steuern gesamt",
};
export const ExportColumns_Default_Base = [
    "createdAt",
    "totalAmount",
    "paymentMethod",
    "dafProvider",
    "status",
    "payoutDate",
    "extraDonation",
    "refundedAmount",
    "recurringStatus",
    "firstName",
    "lastName",
    "companyName",
    "email",
    "receiptNumber",
    "receiptUrl",
    "eligibleAmount",
    "rateTitle",
    "itemAmount",
    "ticketNumber",
    "addOnNumber",
    "eTicketUrl",
    "canceled",
    "details",
    "note",
    "customQuestions",
    "taxes",
    "selectedFund",
];
export const ExportColumns_Default_All = [...ExportColumns_Default_Base, "formTitle"];
export const ExportColumns_Default_PeerToPeer = [
    ...ExportColumns_Default_Base,
    "formTitle",
    "formLink",
    "campaignTitle",
    "teamTitle",
];
export const getDefaultExportColumns = ({ exportFormType, exportType, timezone, locale, hideCampaignInfo, canGenerateReceipt, canRecordDaf, }) => {
    const { columnsHeaders } = getPaymentExportColumns({
        exportFormType,
        exportType,
        timezone,
        locale,
        hideCampaignInfo,
        canGenerateReceipt,
        canRecordDaf,
    });
    const displayedColumns = Object.keys(columnsHeaders);
    const defaultColumnsArray = exportFormType === ExportFormType.AllForms
        ? ExportColumns_Default_All
        : exportFormType === ExportFormType.PeerToPeer
            ? ExportColumns_Default_PeerToPeer
            : ExportColumns_Default_Base;
    return displayedColumns.filter((key) => defaultColumnsArray.includes(key));
};
